var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 39,
    height: 39,
    rx: 5.5,
    stroke: "#D2D6DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 14.5V13.7C24 12.5799 24 12.0198 23.782 11.592C23.5903 11.2157 23.2843 10.9097 22.908 10.718C22.4802 10.5 21.9201 10.5 20.8 10.5H19.2C18.0799 10.5 17.5198 10.5 17.092 10.718C16.7157 10.9097 16.4097 11.2157 16.218 11.592C16 12.0198 16 12.5799 16 13.7V14.5M18 20V25M22 20V25M11 14.5H29M27 14.5V25.7C27 27.3802 27 28.2202 26.673 28.862C26.3854 29.4265 25.9265 29.8854 25.362 30.173C24.7202 30.5 23.8802 30.5 22.2 30.5H17.8C16.1198 30.5 15.2798 30.5 14.638 30.173C14.0735 29.8854 13.6146 29.4265 13.327 28.862C13 28.2202 13 27.3802 13 25.7V14.5",
    stroke: "#4D5761",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteOutline);
export default __webpack_public_path__ + "static/media/DeleteOutline.b305026b9e2417341c1628fe5af46310.svg";
export { ForwardRef as ReactComponent };